/**
 * Which payment methods the cart may offer, and why some are missing.
 *
 * - A wallet method with no balance means this member has no slot to spend
 *   from; the button could only fail.
 * - Inside the packaged phone app a GATEWAY method (card, Dragonpay, iPay88)
 *   is dropped: the handoff is a plain navigation that Capacitor opens in the
 *   phone's browser, and the gateway returns the buyer to the app's own
 *   hostname, which is not a website. The website offers those methods and
 *   says so in the cart, so nothing is sold in-app that the web cannot sell.
 */
export type CartMethodLike = { settlement: string; balance: string | null };

export function visibleCartMethods<M extends CartMethodLike>(
  methods: M[],
  opts: { native: boolean },
): { methods: M[]; hiddenGateways: number } {
  const usable = methods.filter((m) => !(m.settlement === 'wallet' && m.balance === null));
  if (!opts.native) return { methods: usable, hiddenGateways: 0 };
  const kept = usable.filter((m) => m.settlement !== 'gateway');
  return { methods: kept, hiddenGateways: usable.length - kept.length };
}
